import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import SmsTemplates from "@/pages/Pages/Templates/SmsTemplates.vue";
import SmsTemplate from "@/pages/Pages/Templates/SmsTemplate.vue";
import CallTemplates from "@/pages/Pages/Templates/CallTemplates.vue";
import CallTemplate from "@/pages/Pages/Templates/CallTemplate.vue";
import CallSounds from "@/pages/Pages/Templates/CallSounds.vue";
import EmailTemplates from "@/pages/Pages/Templates/EmailTemplates.vue";
import EmailTemplate from "@/pages/Pages/Templates/EmailTemplate.vue";
import PushTemplates from "@/pages/Pages/Templates/PushTemplates.vue";
import PushTemplate from "@/pages/Pages/Templates/PushTemplate.vue";
import ViberTemplates from "@/pages/Pages/Templates/ViberTemplates.vue";
import ViberTemplate from "@/pages/Pages/Templates/ViberTemplate.vue";
import WhatsappTemplates from "@/pages/Pages/Templates/WhatsappTemplates.vue";
import WhatsappTemplate from "@/pages/Pages/Templates/WhatsappTemplate.vue";
import CustomTemplates from "@/pages/Pages/Templates/CustomTemplates.vue";
import CustomTemplate from "@/pages/Pages/Templates/CustomTemplate.vue";
import MailNotifyTemplates from "@/pages/Pages/Templates/MailNotifyTemplates.vue";
import MailNotifyTemplate from "@/pages/Pages/Templates/MailNotifyTemplate.vue";

let reportMenu = {
  path: "/",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: "/template/sms",
      name: "distribution_template_sms",
      component: SmsTemplates,
      meta: {
        icon: "sms",
        msgKey: 'menu.item.templates.sms'
      }
    },
    {
      path: "/template/sms/new",
      name: "distribution_template_sms_new",
      component: SmsTemplate,
      meta: {
        parentPath: "/template/sms",
        msgKey: 'menu.item.templates.sms'
      }
    },
    {
      path: "/template/sms/:id",
      name: "distribution_template_sms_edit",
      component: SmsTemplate,
      meta: {
        parentPath: "/template/sms",
        msgKey: 'menu.item.templates.sms'
      }
    },
    {
      path: "/template/call",
      name: "distribution_template_call",
      component: CallTemplates,
      meta: {
        icon: "call",
        msgKey: 'menu.item.templates.call'
      }
    },
    {
      path: "/template/call/new",
      name: "distribution_template_call_new",
      component: CallTemplate,
      meta: {
        parentPath: "/template/call",
        msgKey: 'menu.item.templates.call'
      }
    },
    {
      path: "/template/call/:id",
      name: "distribution_template_call_edit",
      component: CallTemplate,
      meta: {
        parentPath: "/template/call",
        msgKey: 'menu.item.templates.call'
      }
    },
    {
      path: "/call/sound",
      name: "distribution_template_call_sound",
      component: CallSounds,
      meta: {
        showBack: true,
        msgKey: 'menu.item.templates.call'
      }
    },
    {
      path: "/template/email",
      name: "distribution_template_email",
      component: EmailTemplates,
      meta: {
        icon: "email",
        msgKey: 'menu.item.templates.email'
      }
    },
    {
      path: "/template/email/new",
      name: "distribution_template_email_new",
      component: EmailTemplate,
      meta: {
        parentPath: "/template/email",
        msgKey: 'menu.item.templates.email'
      }
    },
    {
      path: "/template/email/:id",
      name: "distribution_template_email_edit",
      component: EmailTemplate,
      meta: {
        parentPath: "/template/email",
        msgKey: 'menu.item.templates.email'
      }
    },
    {
      path: "/template/push",
      name: "distribution_template_push",
      component: PushTemplates,
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.templates.push'
      }
    },
    {
      path: "/template/push/new",
      name: "distribution_template_push_new",
      component: PushTemplate,
      meta: {
        parentPath: "/template/push",
        msgKey: 'menu.item.templates.push'
      }
    },
    {
      path: "/template/push/:id",
      name: "distribution_template_push_edit",
      component: PushTemplate,
      meta: {
        parentPath: "/template/push",
        msgKey: 'menu.item.templates.push'
      }
    },
    {
      path: "/template/viber",
      name: "distribution_template_viber",
      component: ViberTemplates,
      meta: {
        icon: "forum",
        msgKey: 'menu.item.templates.viber'
      }
    },
    {
      path: "/template/viber/new",
      name: "distribution_template_viber_new",
      component: ViberTemplate,
      meta: {
        parentPath: "/template/viber",
        msgKey: 'menu.item.templates.viber'
      }
    },
    {
      path: "/template/viber/:id",
      name: "distribution_template_viber_edit",
      component: ViberTemplate,
      meta: {
        parentPath: "/template/viber",
        msgKey: 'menu.item.templates.viber'
      }
    },
    {
      path: "/template/whatsapp",
      name: "distribution_template_whatsapp",
      component: WhatsappTemplates,
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.templates.whatsapp'
      }
    },
    {
      path: "/template/whatsapp/new",
      name: "distribution_template_whatsapp_new",
      component: WhatsappTemplate,
      meta: {
        parentPath: "/template/whatsapp",
        msgKey: 'menu.item.templates.whatsapp'
      }
    },
    {
      path: "/template/whatsapp/:id",
      name: "distribution_template_whatsapp_edit",
      component: WhatsappTemplate,
      meta: {
        parentPath: "/template/whatsapp",
        msgKey: 'menu.item.templates.whatsapp'
      }
    },
    {
      path: "/template/custom",
      name: "distribution_template_custom",
      component: CustomTemplates,
      meta: {
        icon: "forum",
        msgKey: 'menu.item.templates.custom'
      }
    },
    {
      path: "/template/custom/new",
      name: "distribution_template_custom_new",
      component: CustomTemplate,
      meta: {
        parentPath: "/template/custom",
        msgKey: 'menu.item.templates.custom'
      }
    },
    {
      path: "/template/custom/:id",
      name: "distribution_template_custom_edit",
      component: CustomTemplate,
      meta: {
        parentPath: "/template/custom",
        msgKey: 'menu.item.templates.custom'
      }
    },
    {
      path: "/template/mail_notify",
      name: "distribution_template_mail_notify",
      component: MailNotifyTemplates,
      meta: {
        icon: "mark_email_unread",
        msgKey: 'menu.item.templates.mail_notify'
      }
    },
    {
      path: "/template/mail_notify/new",
      name: "distribution_template_mail_notify_new",
      component: MailNotifyTemplate,
      meta: {
        parentPath: "/template/mail_notify",
        msgKey: 'menu.item.templates.mail_notify'
      }
    },
    {
      path: "/template/mail_notify/:id",
      name: "distribution_template_mail_notify_edit",
      component: MailNotifyTemplate,
      meta: {
        parentPath: "/template/mail_notify",
        msgKey: 'menu.item.templates.mail_notify'
      }
    },
  ]
};

export default reportMenu;